module.exports = __webpack_public_path__ + "img/pinecones.b8d1ce41.jpg";